import { ChangeDetectorRef, Component, Renderer2 } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { combineLatest, forkJoin, map, Observable, switchMap, take } from 'rxjs';
import { ContentService } from '../../spartacus/services/content.service';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { BaseSiteService, CmsBannerComponent, CmsService, OccConfig } from '@spartacus/core';
import { HelpnfaqsearchPipe } from '../../cms-common/Pipes/helpnfaqsearch.pipe';

@Component({
    selector: 'app-uk-lo-second',
    templateUrl: './uk-lo-second.component.html',
    styleUrls: ['./uk-lo-second.component.scss'],
    standalone: false
})
export class UkLoSecondComponent {
  constructor(public component: CmsComponentData<CmsBannerComponent>, public accessService: ContentService, private cmsService: CmsService, public cd: ChangeDetectorRef, private userInfoService: UserInfoService, protected config: OccConfig, private baseSiteService: BaseSiteService, private renderer: Renderer2) { }
  secondnode: Observable<any> = this.component.data$;
  activeIndexes: Set<string> = new Set();
  activeAccordion: number | null = null;
  mergedObject1: any = [];
  mergedObject2: any = [];
  filteredData: any[] = [];
  seallbtn: boolean = false;
  searchvalue: string = '';
  searchresults: boolean = false;
  shownoresult: boolean = false;
  userLoggedIn: boolean = false;
  userInfo: any;
  currentSite: string | undefined;
  isModalOpen = false;
  popupdata: any;
  private activeDiv: HTMLElement | null = null;
  ngOnInit() {
    window.onfocus = this.handleWindowFocus.bind(this);
    this.secondnode.pipe(take(1)).subscribe(res => {
      this.loadFaqData(res);
    });

    //for looged, loggedout
    this.userInfoService.userLoggedIn$.subscribe(res => {
      this.userLoggedIn = res;
      if (this.userLoggedIn) {
        this.userInfoService.getUserData().subscribe(res => {
          if (res) {
            this.userInfo = res;
          }
        });
      }
      this.cd.detectChanges();
    })
    //to get the current basesite 
    this.baseSiteService.getActive().subscribe((siteId) => {
      this.currentSite = siteId;
    });
    this.cmsService.getComponentData('contactusPagePopup').subscribe(res => {
      this.popupdata = res;
    });
  }
  ngOnDestroy() {
    window.onfocus = null;
  }
  handleWindowFocus() {
    if (this.isModalOpen) {
      this.closeModal();
    }
  }
  loadFaqData(res: any) {
    const tilesList = res.FaqAllResources.split(" ");
    this.accessService.opeffeaturedResources(tilesList).subscribe((res: any) => {
      if (Array.isArray(res.component)) {
        this.mergedObject1 = res.component;
        res.component.forEach((item: any) => {
          const subtilesList = item.faqTopics.split(" ");
          if (subtilesList.length <= 9) {
            this.accessService.opeffeaturedResources(subtilesList).subscribe((subRes: any) => {
              if (Array.isArray(subRes.component)) {
                const updatedsubRes = subRes.component.map((data: any) => ({
                  ...data,
                  parentId: item.uid,
                }));
                const uniqueEntries = updatedsubRes.filter(
                  (newItem: { uid: any }) =>
                    !this.mergedObject2.some((existingItem: { uid: any }) => existingItem.uid === newItem.uid)
                );
                this.mergedObject2 = [...this.mergedObject2, ...uniqueEntries];
                this.sortMergedObject2ByUid();
                this.cd.detectChanges();
              }
            });
          } else {
            const sublistcount = subtilesList.length;
            const sublistloop = Math.ceil(sublistcount / 9); // Calculate the number of chunks
            let sliceIndex = 0;
            let lastIndex = 9;

            const observables = []; // Collect all observables

            for (let j = 0; j < sublistloop; j++) {
              const spliceList = subtilesList.slice(sliceIndex, lastIndex); 
              observables.push(this.accessService.opeffeaturedResources(spliceList));
              sliceIndex = lastIndex;
              lastIndex += 9;
            }

            // Wait for all observables to complete
            forkJoin(observables).subscribe((responses: any[]) => {
              responses.forEach((res: any) => {
                if (Array.isArray(res.component)) {
                  const updatedsubRes = res.component.map((data: any) => ({
                    ...data,
                    parentId: item.uid,
                  }));
                  this.mergedObject2 = [...this.mergedObject2, ...updatedsubRes]; // Merge arrays
                }
              });

              // Sort mergedObject2 based on uid after all responses are processed
              this.sortMergedObject2ByUid();
              this.cd.detectChanges();
            });
          }
        });
      } else if (res.component) {
        this.mergedObject1 = [res.component];
        this.cd.detectChanges();
      }
    });
  }
  // Helper method to sort mergedObject2 by uid
  sortMergedObject2ByUid() {
    this.mergedObject2.sort((a: any, b: any) => {
      // Convert uid to numbers for proper numerical sorting
      return parseInt(a.uid, 10) - parseInt(b.uid, 10);
    });
  }
  //when user searches something the following method will be useful for showing relavant searches
  applyFilter(mysearchvalue: any) {
    if (mysearchvalue.length > 0) {
      let final = mysearchvalue.trim().toLowerCase();
      const filteredData1 = new HelpnfaqsearchPipe().transform(this.mergedObject2, final);
      if (this.filteredData) {
        this.searchresults = true;
      }
      //when the search doesn't match or the user gives empty the no result will be opened
      if (final != " " && filteredData1.length < 1) {
        this.shownoresult = true;
      }
      else {
        this.shownoresult = false;
      }
      //iam assigning the filteredData1 to one variable so that i can use in html
      this.filteredData = filteredData1;
      return filteredData1
    }
    else {
      this.shownoresult = false;
      this.searchresults = false;
    }
  }
  //the following is to show all the accordions initally
  toggleDropdown(i: number, j: number) {
    const key = `${i}-${j}`;
    if (this.activeIndexes.has(key)) {
      this.activeIndexes.delete(key);
    } else {
      this.activeIndexes.add(key);
    }
  }
  isActive(i: number, j: number): boolean {
    const key = `${i}-${j}`;
    return this.activeIndexes.has(key);
  }
  showAccordion(index: number, myid: string) {
    this.activeAccordion = index; // Always show only the selected section
    this.seallbtn = true; // Show the "See All Topics" button
    const div = <HTMLElement>document.getElementById(myid);
    if (this.activeDiv) {
      this.renderer.removeClass(this.activeDiv, 'btn-active-class');
    }
    if (div) {
      this.renderer.addClass(div, 'btn-active-class');
    }
    this.activeDiv = div;
    this.cd.detectChanges();
  }
  //when clicking on SEE ALL TOPICS button to make every accordion appear again
  sealltopics() {
    this.activeAccordion = null; // Reset to show all accordions
    this.seallbtn = false; // Hide the "See All Topics" button
    this.renderer.removeClass(this.activeDiv, 'btn-active-class');
    this.cd.detectChanges();
  }
  //search functions
  toggleSearchAccordion(index: any) {
    if (this.activeIndexes.has(index)) {
      this.activeIndexes.delete(index);
    } else {
      this.activeIndexes.add(index);
    }
  }
  issearchActive(index: any) {
    return this.activeIndexes.has(index);
  }
  //i wrote this for to show the results in accordions 
  toggleAccordion(item: any) {
    item.isOpen = !item.isOpen;
  }
  //for popup
  openModal() {
    this.isModalOpen = true;
    document.body.style.overflowY = 'auto';
    document.getElementById('help_Faq_commonleaving_abandonedPop')!.style.display = 'block';
  }
  closeModal() {
    this.isModalOpen = false;
    document.body.style.overflowY = 'auto';
    document.getElementById('help_Faq_commonleaving_abandonedPop')!.style.display = 'none';
  }
}
